<template>
  <modal
    class="ce-userValidation"
    @close="close"
    :headline="$t('userProfile.requestValidationModal.headline')">
    <div class="ce-modalContent">
      <div>
        <p class="mt0 mb3">
          {{ $t('userProfile.requestValidationModal.content') }}
        </p>
      </div>

      <v-form
        ref="validationObserver"
        tag="div"
        v-slot="{ values }"
        @submit="submit">
        <validated-select
          name="region"
          :label="$t('userValidation.region.label')"
          :options="contactRegionOptions"
          rules="required"
          :use-key-only-value="false"
        />

        <validated-select
          v-if="values.region && values.region.subRegions"
          name="subRegion"
          :label="$t('userValidation.subRegion.label')"
          :options="values.region.subRegions"
          rules="required"
          :use-key-only-value="false" />

        <div>
          <button
            class="ce-btn ce-btn-light"
            type="submit">
            <template v-if="loading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('userValidation.submitCta') }}
            </template>
          </button>

          <button
            class="ce-btn ce-btn-grey"
            @click.prevent="close">
            {{ $t('userValidation.cancelCta') }}
          </button>
        </div>
      </v-form>
    </div>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        region: 'europe',
        subRegion: null
      },
      loading: false
    };
  },
  computed: {
    ...mapState('generic', ['contactRegions']),
    ...mapGetters('user', ['tokenPayload']),
    contactRegionOptions() {
      return this.contactRegions.map((contactRegion) => ({
        ...contactRegion,
        value: contactRegion.code
      }));
    },
    selectedRegion() {
      if (this.form.region) {
        return this.contactRegions.find((r) => r.code === this.form.region);
      }

      return null;
    },
    selectedSubRegion() {
      if (this.selectedRegion
        && this.selectedRegion.subRegions
        && this.form.subRegion) {
        return this.selectedRegion.subRegions.find((sR) => sR.code === this.form.subRegion);
      }

      return null;
    }
  },
  methods: {
    ...mapActions('user', ['requestValidation']),
    close() {
      this.$emit('close');
    },
    async submit(values) {
      this.loading = true;

      await this.requestValidation({
        ...values,
      });
      this.close();

      this.loading = false;
    }
  }
};
</script>
